export const names = {
  darkMode: "twindy-headless.darkMode",
}
